import { type ParentComponent, Show } from "solid-js";
import { useHelpTooltipsPreference } from "~/hooks/useHelpTooltipsPreference";

/** Omits Learn more / info doc links when that slice is hidden (see Help Tooltips setting). */
export const WhenTooltipsAllowed: ParentComponent = (props) => {
  const { showLearnMoreLinks } = useHelpTooltipsPreference();
  return <Show when={showLearnMoreLinks()}>{props.children}</Show>;
};
